import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DateConverter from "@heartinz/date_and_time_processor";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import PriceCalculator from "@heartinz/gst_india_product_price_calculator";
import TotalCalculator from "@heartinz/checkout_billing_price_validator";
import { CircularProgress } from "@mui/material";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import EditUpdateQty from "./EditUpdateQty";
import EditAlert from "./EditAlert";
// import { useAuth } from "../../../context/AuthProvider";
import ChangeModal from "./ChangeModal";
import EditService from "../service/EditService";
import CustomerModal from "./CustomerModal";
import EditRecharge from "../recharge/EditRecharge";
import UpdatePrice from "./UpdatePrice";
import { getLastRoute } from "../../../context/LocationTracker";
import DeleteModal from "../../../constants/DeleteModal";
import { usePermission } from "../../../context/PermissionContext";
import EditCutomer from "../customer/EditCustomer";
import ProductNoteModal from "./Note";
import { useContextApi } from "../../../context/ContextApi";
import SearchInput from "../../../constants/SearchInput";
import AddCustomer from "../customer/AddCustomer";
import ProductSearchList from "../../../constants/ProductSearchList";
import { useAuth } from "../../../context/AuthProvider";
import dayjs from "dayjs";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ProjectSale from "./ProjectSale";
import { CalendarIcon, CheckIcon, ChevronRightIcon, CircleIcon, DeleteIcon, EditIcon, LineDoubleIcon, MinusIcon, NotepadIcon, RemoveIcon, TimerIcon, XIcon } from "../../../constants/Icons";

const OldEditSale = ({ onDone, isActive }) => {
  const { state } = useLocation();
  const backTo = getLastRoute() || "/";
  // const { isUser, isLoading, handleLogout } = useAuth();
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [error, setErrors] = useState({});
  const { isUser } = useAuth();
  const {
    estimateSuggest,
    handleSuggestService,
    serviceNameSuggest,
    setServiceNameSuggest,
    customerSearchTerm,
    customerSuggestions,
    setCustomerSearchTerm,
    isCustomerData,
    setCustomerData,
    handleCustomerSearch,
    setCustomerSuggestions,
  } = useContextApi();
  const navigate = useNavigate();

  //**************** Ref ******************//
  const suggestionRefs = useRef([]);
  const cashRef = useRef(null);
  const cardRef = useRef(null);
  const onlineRef = useRef(null);
  const upiRef = useRef(null);
  const paylaterRef = useRef(null);
  const buttonRef = useRef(null);

  const [isBtnLoading, setBtnLoading] = useState(false);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [currentNoteProduct, setCurrentNoteProduct] = useState(null);

  //**************** Date ***************//

  const [projectId, setProjectId] = useState("");
  const [resetProject, setResetProject] = useState(false);

  const serverTime = GetServerLiveTime();
  // console.log(serverTime);
  const [saleDate, setSaleDate] = useState(dayjs(serverTime));
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [saleDateApi, setSaleDateApi] = useState("");
  const [originalSaleDate, setOriginalSaleDate] = useState("");
  const maxDate = originalSaleDate
    ? dayjs(originalSaleDate).endOf("day")
    : dayjs(serverTime).endOf("day");

  const minDate = originalSaleDate
    ? dayjs(originalSaleDate).subtract(5, "month").startOf("day")
    : dayjs(serverTime).subtract(5, "month").startOf("day");

  const [saleNo, setSaleNo] = useState(null);
  const [imode, setImode] = useState(null);

  //**************** Cart ******************//
  const [saleid, setSaleId] = useState(null);
  const [isSaleEdit, setSaleEdit] = useState(false);
  const [ecart, setECart] = useState([]);

  const [totalPayable, setTotalPayable] = useState(0);
  const [totalMRP, setTotalMRP] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalSaleprice, setTotalSalePrice] = useState(0);
  const [totalSoldprice, setTotalSoldPrice] = useState(0);
  const [totalTaxamount, setTotalTaxAmount] = useState(0);
  const [totalBaseprice, setTotalBasePrice] = useState(0);
  const [totalQty, setTotalQuantity] = useState(0);
  const [numberSuggest, setNumberSuggest] = useState([]);

  const [oldCash, setOldCash] = useState(null);
  const [oldCard, setOldCard] = useState(null);
  const [oldUpi, setOldUpi] = useState(null);
  const [oldPaylater, setOldPaylater] = useState(null);

  const [totalSaleRes, setSaleTotals] = useState(0);
  const [totalSoldRes, setSoldTotals] = useState(0);

  const [cash, setCash] = useState(0);
  const [card, setCard] = useState(0);
  const [upi, setUpi] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [paylater, setPaylater] = useState(0);
  const [online, setOnline] = useState(0);
  const [remineDiscount, setRemineDiscount] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [balance, setBalance] = useState(totalPayable);

  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [isChangeModalOpen, setChangeModalOpen] = useState(false);

  const [isEditServiceModalOpen, setEditServiceModalOpen] = useState(false);
  const [isServiceData, setServiceData] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [isEditSalePriceData, setEditSalePriceData] = useState(null);
  const [isEditSalePriceModelOpen, setEditSalePriceModelOpen] = useState(false);
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [isEditRechargeData, setEditRechargeData] = useState(null);
  const [isEditRechargeModelOpen, setEditRechargeModelOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleteData, setDeleteData] = useState(null);
  const {
    permission,
    blockedPermissions,
    hasPermission,
    viewOption,
    customerGroups,
    hasModulePermission,
    globelPopupOpen,
  } = usePermission();
  const [addGroupload, setAddGroupLoad] = useState(false);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const hasFetched = useRef(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [groupName, setGroupName] = useState(customerGroups);
  //*************** Default **************//

  const handleOutsideClick = (e) => {
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target) &&
      !isCustomerModalOpen
    ) {
      handleResetCustomer();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (state?._id) {
      setSaleId(state._id);
    }
    if (state?.saleno) {
      setSaleNo(state.saleno);
    }
    if (state?.imode) {
      setImode(state.imode);
    }
    if (state?.saleto) {
      setSelectedCustomer(state.saleto);
    }
    if (state?.projectid) {
      setProjectId(state?.projectid);
    }
    if (state?.saledate) {
      setSaleDate(dayjs(state.saledate));
      setSaleDateApi(state.saledate);
      setOriginalSaleDate(state.saledate);
    }
    if (state?.saleitems) {
      const updatedSaleItems = state.saleitems.map((item) => ({
        ...item,
        oldquantity: item.quantity,
        unit: item?.unitConfig?.primaryUnitCode,
      }));
      setECart(updatedSaleItems);
      localStorage.setItem("nGbLecart", JSON.stringify(updatedSaleItems));
    } else {
      const savedCart = JSON.parse(localStorage.getItem("nGbLecart"));
      if (savedCart && Array.isArray(savedCart)) {
        setECart(savedCart);
      }
    }
    if (state?.cashamount) {
      setCash(CurrencyConverter.toCurrency(state.cashamount, "INR"));
    }
    if (state?.cardamount) {
      setCard(CurrencyConverter.toCurrency(state.cardamount, "INR"));
    }
    if (state?.onlineamount) {
      setOnline(CurrencyConverter.toCurrency(state.onlineamount, "INR"));
    }
    if (state?.upiamount) {
      setUpi(CurrencyConverter.toCurrency(state.upiamount, "INR"));
    }
    if (state?.paylateramount) {
      setPaylater(CurrencyConverter.toCurrency(state.paylateramount, "INR"));
    }
    if (state?.discountamount) {
      setDiscount(CurrencyConverter.toCurrency(state.discountamount, "INR"));
      setRemineDiscount(
        CurrencyConverter.toCurrency(state.discountamount, "INR"),
      );
    }
    if (state?.paidamount) {
      setTotalPaid(state.paidamount);
    }
    if (state?.paidamount) {
      setTotalPayable(state.paidamount);
    }
    if (state?.balance) {
      setBalance(CurrencyConverter.toCurrency(state.balance, "INR"));
    }
    setSaleEdit(state?._id);
  }, [state]);

  useEffect(() => {
    localStorage.setItem("nGbLecart", JSON.stringify(ecart));
    calculateTotal();
  }, [ecart]);

  const handleSaleDate = (newValue) => {
    if (!newValue) return;

    setSaleDate(newValue);

    const saleDateApi = DateConverter.convertToTimeZone(
      newValue.toISOString(),
      isUser?.timezone,
    );
    setSaleDateApi(saleDateApi);
    setOpenDatePicker(false);
  };

  const calculateTotal = () => {
    // var totalPay = ecart.reduce((total, item) => total + item.lineGrandTotal, 0);
    // setTotalPayable(CurrencyConverter.toCurrency(totalPay || 0, "INR"));

    var totalMrPrice = ecart.reduce(
      (total, item) => total + item.lineTotalMrp,
      0,
    );
    setTotalMRP(CurrencyConverter.toCurrency(totalMrPrice || 0, "INR"));

    // var totalDis = ecart.reduce((total, item) => total + item.lineTotalDiscount, 0);
    // setTotalDiscount(CurrencyConverter.toCurrency(totalDis || 0, "INR"));

    var totalSold = ecart.reduce(
      (total, item) => total + item.lineTotalSoldPrice,
      0,
    );
    setTotalSoldPrice(CurrencyConverter.toCurrency(totalSold || 0, "INR"));

    var totalSale = ecart.reduce(
      (total, item) => total + item.lineTotalSalePrice,
      0,
    );
    setTotalSalePrice(CurrencyConverter.toCurrency(totalSale || 0, "INR"));

    var totalBase = ecart.reduce(
      (total, item) => total + item.lineTotalBasePrice,
      0,
    );
    setTotalBasePrice(CurrencyConverter.toCurrency(totalBase || 0, "INR"));

    var totalTax = ecart.reduce(
      (total, item) => total + item.lineTotalTaxAmount,
      0,
    );
    setTotalTaxAmount(CurrencyConverter.toCurrency(totalTax || 0, "INR"));

    var totalQty = ecart.reduce((total, item) => total + item.quantity, 0);
    setTotalQuantity(totalQty);

    var totalSaleRes = PriceCalculator.getGrandTotal(
      totalMrPrice,
      totalSale,
      totalBase,
      totalTax,
    );
    var totalSoldRes = PriceCalculator.getGrandTotal(
      totalMrPrice,
      totalSold,
      totalBase,
      totalTax,
    );
    setSaleTotals(totalSaleRes);
    setSoldTotals(totalSoldRes);
    setTotalPayable(totalSoldRes.grandtotal);
  };

  const handleFocusFill = (mode) => {
    const grandTotal = Number(
      CurrencyConverter.toCurrency(totalSoldRes.grandtotal || 0, "INR"),
    );

    const currentCash = Number(cash || 0);
    const currentCard = Number(card || 0);
    const currentUpi = Number(upi || 0);
    const currentonline = Number(online || 0);
    const currentPaylater = Number(paylater || 0);

    const totalAlreadyPaid =
      currentCash + currentCard + currentonline + currentUpi + currentPaylater;

    const remainingBalance = grandTotal - totalAlreadyPaid;

    if (remainingBalance <= 0) return;

    // Set untouched fields to 0 if they were empty
    if (!cash) setCash(0);
    if (!card) setCard(0);
    if (!upi) setUpi(0);
    if (!online) setOnline(0);
    if (!paylater) setPaylater(0);

    // Add remainingBalance to the selected mode
    if (mode === "cash") {
      setCash(currentCash + remainingBalance);
      setTimeout(() => cashRef?.current?.select(), 0);
    } else if (mode === "card") {
      setCard(currentCard + remainingBalance);
      setTimeout(() => cardRef?.current?.select(), 0);
    } else if (mode === "online") {
      setOnline(currentonline + remainingBalance);
      setTimeout(() => onlineRef?.current?.select(), 0);
    } else if (mode === "upi") {
      setUpi(currentUpi + remainingBalance);
      setTimeout(() => upiRef?.current?.select(), 0);
    } else if (mode === "paylater") {
      setPaylater(currentPaylater + remainingBalance);
      setTimeout(() => paylaterRef?.current?.select(), 0);
    }
  };

  const handleEnterFocus = (
    e,
    nextRef,
    mode,
    currentValue,
    nextMode,
    nextValue,
  ) => {
    if (e.key === "Enter") {
      e.preventDefault();

      const numericValue = Number(currentValue || 0);
      const nextNumericValue = Number(nextValue || 0);

      // ✅ Prefill *next* input if it's empty (not current)
      if (nextMode && !nextNumericValue) {
        handleFocusFill(nextMode);
      }

      // Move to next input
      nextRef?.current?.focus();
    }
  };

  const updateQuantity = (productId, Uindex, newQty) => {
    if (newQty <= 0) {
      removeEItem(Uindex);
    }
    const product = ecart.find(
      (product) => product._id === productId && Uindex === isEditCartIndex,
    );
    if (product) {
      var oldQty = product.oldquantity;
    }
    setECart((prevCart) =>
      prevCart.map((item, index) => {
        if (item._id === productId && index === Uindex) {
          const enteredQty = parseInt(newQty);
          if (enteredQty > oldQty) {
            return {
              ...item,
              quantity: oldQty,
            };
          }
          if (enteredQty > 0 && enteredQty <= oldQty) {
            var saleRes = PriceCalculator.getAllPriceList(
              item.mrp,
              item.saleprice,
              item.baseprice,
              item.taxpercentage,
              enteredQty,
              item.isLock,
            );

            var soldRes = PriceCalculator.getAllPriceList(
              item.mrp,
              item.soldprice,
              item.baseprice,
              item.taxpercentage,
              enteredQty,
              "SALEPRICE",
            );

            return {
              ...item,
              baseprice: soldRes.basePrice,
              discount: soldRes.discount,
              taxamount: soldRes.taxAmount,
              quantity: enteredQty,
              lineGrandTotal: soldRes.lineGrandTotal,
              lineTotalBasePrice: soldRes.lineTotalBasePrice,
              lineTotalDiscount: soldRes.lineTotalDiscount,
              lineTotalMrp: soldRes.lineTotalMrp,
              lineTotalSalePrice: saleRes.lineTotalSalePrice,
              lineTotalSoldPrice: soldRes.lineTotalSalePrice,
              lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
            };
          }
        } else {
          return item;
        }
      }),
    );
  };

  const removeEItem = (indexToRemove) => {
    if (isSaleEdit) {
      setECart((prevCart) => {
        return prevCart.filter((_, index) => index !== indexToRemove);
      });
    } else {
      setAlertModalOpen(true);
    }
  };

  const [isQuantityModalOpen, setQuantityModalOpen] = useState(false);
  const [isQuantityData, setQunatityItem] = useState(null);
  const [isEditCartIndex, setEditCartIndex] = useState(null);

  const handleQuantity = async (item, Nindex) => {
    if (isSaleEdit) {
      setQuantityModalOpen(true);
      setQunatityItem(item);
      setEditCartIndex(Nindex);
    } else {
      setAlertModalOpen(true);
    }
  };

  const handleQuantityClose = () => {
    setQuantityModalOpen(false);
    setQunatityItem(null);
    setEditCartIndex(null);
  };

  const handleQuantityUpdate = async (item, Uindex, newQty) => {
    updateQuantity(item, Uindex, newQty);
    handleQuantityClose();
  };

  const handleAlertClose = () => {
    setAlertModalOpen(false);
  };

  const editSalePriceClose = () => {
    setEditSalePriceModelOpen(false);
  };

  const handleEditRechargeClose = () => {
    setEditRechargeModelOpen(false);
  };

  //*************** Customer **************//
  const customerSuggestionsRef = useRef(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isCustomerLoading, setIsCustomerLoading] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);

  const [isCustomerModalOpen, setCustomerModalOpen] = useState(false);

  // const handleSelectCustomer = (customer) => {
  //   setSelectedCustomer(customer);
  //   handleResetCustomer();
  // };

  const handleRemoveCustomer = () => {
    setSelectedCustomer(null);
    setCustomerSearchTerm("");
    setCustomerSuggestions([]);
    setShowCustomerDropdown(false);
  };

  const handleSelectCustomer = async (customer) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/customer/details/${customer._id}`,
      );
      const fullCustomer = response.data.results;
      setSelectedCustomer(fullCustomer.customerData);
      setCustomerData(fullCustomer);
      setCustomerSearchTerm("");
      setCustomerSuggestions([]);
      handleResetCustomer();
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const openEditModal = (cItem) => {
    if (
      blockedPermissions("CUSTOMER:viewDetails") ||
      permission === undefined
    ) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdte = async (updatedData) => {
    const editableKeys = [
      "name",
      "phone",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
      "shippingaddressline1",
      "shippingaddressline2",
      "shippingstate",
      "shippingcity",
      "shippingdistrict",
      "shippingpincode",
      "shippingcountry",
      "website",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }

    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }

    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        shippingAddress: {
          addressline1: updatedData.shippingaddressline1,
          addressline2: updatedData.shippingaddressline2,
          district: updatedData.shippingdistrict,
          city: updatedData.shippingcity,
          state: updatedData.shippingstate,
          statecode: updatedData.shippingstatecode,
          country: updatedData.shippingcountry,
          pincode: updatedData.shippingpincode,
        },

        // ✅ Contact Person Object
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/customer/${updatedData._id}`,
        data,
      );
      showAlert("success", Messages.SUCCESS.CUSTOMER_UPDATED);
      setCustomerData(response.data.results);
      setSelectedCustomer(response.data.results);
      closeEditModal();
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  //**************** Payment ***************//
  const [isSaleModalOpen, setSaleModalOpen] = useState(false);
  const [data, setSaleData] = useState(null);

  const handleInputChange = (setValue) => (e) => {
    const value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setValue(value);
    } else {
      setValue(0);
    }
  };

  useEffect(() => {
    var cashAmt = CurrencyConverter.toSubunit(cash || 0, "INR");
    var cardAmt = CurrencyConverter.toSubunit(card || 0, "INR");
    var upiAmt = CurrencyConverter.toSubunit(upi || 0, "INR");
    var disAmt = CurrencyConverter.toSubunit(discount || 0, "INR");
    var onlineAmt = CurrencyConverter.toSubunit(online || 0, "INR");
    var paylaterAmt = CurrencyConverter.toSubunit(paylater || 0, "INR");
    var payObject = {
      cashamount: cashAmt,
      cardamount: cardAmt,
      onlineamount: onlineAmt,
      discountamount: disAmt,
      upiamount: upiAmt,
      paylateramount: paylaterAmt,
    };
    var totalVal = TotalCalculator.validateCheckout(totalPayable, payObject);
    setTotalPaid(totalVal.totalPaid);
    setBalance(totalVal.balance);
    // if (totalVal.balance < 0) {
    //   setPaylater(0);
    // }
  }, [cash, card, online, upi, discount, paylater, totalPayable]);

  const prevTotalPayable = useRef(totalPayable);

  useEffect(() => {
    if (totalPayable < prevTotalPayable.current) {
      if (paylater > 0) setOldPaylater(paylater);
      setPaylater(0);
    }
    prevTotalPayable.current = totalPayable;
  }, [totalPayable]);

  const handleCancel = () => {
    setECart([]);
    localStorage.removeItem("nGbLecart");
    setProjectId("");
    setResetProject((prev) => !prev);
    setCash(0);
    setCard(0);
    setOnline(0);
    setUpi(0);
    setDiscount(0);
    setPaylater(0);
    setTotalPaid(0);
    setBalance(0);
    setCustomerSearchTerm("");
    setCustomerSuggestions([]);
    setSelectedCustomer(null);
    handleResetAddCustomer();
    navigate("/listsale", { replace: true });
  };

  const openDeleteModal = (cItem) => {
    if (blockedPermissions("SALE:delete") || permission === undefined) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDelete = async (saleId) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const idToDelete = saleId || isDeleteData._id;

      const response = await AxiosInstance.delete(`module/sale/${idToDelete}`);
      showAlert("success", Messages.SUCCESS.SALE_DELETED);
      navigate("/listSale");
      handleReset();
      if (isDeleteModalOpen) {
        closeDeleteModal();
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const closeDeleteModal = () => {
    setDeleteData(null);
    setDeleteModalOpen(false);
  };

  const handleUpdate = async () => {
    const savedCart = localStorage.getItem("nGbLecart");
    const saleItems = Array.isArray(savedCart)
      ? savedCart
      : JSON.parse(savedCart);

    if (!saleItems || saleItems.length <= 0) {
      openDeleteModal(state);
      return;
    }

    if (
      viewOption("saleSettings", "isCustomerMandatory") &&
      !selectedCustomer
    ) {
      showAlert("error", "Customer is mandatory for this sale");
      customerSuggestionsRef.current?.focus();
      return;
    }
    // if (!saleItems || saleItems.length === 0) {
    //   showAlert("warning", Messages.ERROR.EMPTY_CART);
    //   return;
    // }
    if (paylater > 0 && !selectedCustomer) {
      showAlert("error", Messages.ERROR.PAYLATER_ERROR);
      customerSuggestionsRef.current?.focus();
      return;
    }
    if (totalPayable === totalPaid) {
      handleUpdateSale();
    } else if (totalPaid > totalPayable) {
      setChangeModalOpen(true);
    } else {
      cashRef.current.focus();
      showAlert("warning", Messages.ERROR.INVALID_PAID_AMOUNT);
    }
  };

  const handleChangeModalClose = () => {
    setChangeModalOpen(false);
  };

  const handleChangeConfirm = (changeData) => {
    if (changeData.changeamount !== 0) {
      setPaylater(0);
    }
    if (
      (paylater > 0 || changeData.paylaterchange > 0) &&
      !selectedCustomer?._id
    ) {
      showAlert("warning", Messages.ERROR.CUSTOMER_EMPTY);
      return false;
    }
    setChangeModalOpen(false);
    handleUpdateSale(changeData);
  };

  const handleUpdateSale = async (changeData = {}) => {
    const savedCart = localStorage.getItem("nGbLecart");
    const parsedCart = Array.isArray(savedCart)
      ? savedCart
      : JSON.parse(savedCart);

    // const saleItems = parsedCart.map((item) => ({
    //   _id: item._id,
    //   code: item.code,
    //   hsnsac: item.hsnsac || "",
    //   title: item.title,
    //   mrp: item.mrp,
    //   saleprice: item.saleprice,
    //   soldprice: item.soldprice,
    //   taxpercentage: item.taxpercentage,
    //   baseprice: item.baseprice,
    //   isLock: item.isLock,
    //   isStock: item.isStock,
    //   quantity: item.quantity,
    //   description: item.description || "",
    //   imode: item.imode,
    //   walletid: item.walletid || "",
    //   operator: item.operator || "",
    //   number: item.number || "",
    //   itemNo: item.itemNo || "",
    //   note: item.note || "",
    //   serviceByName: item.serviceByName || "",
    // }));

    const saleItems = parsedCart.map((item) => {
      const commonFields = {
        title: item.title,
        hsnsac: item.hsnsac || "",
        description: item.description || "",
        mrp: item.mrp,
        saleprice: item.saleprice,
        soldprice: item.soldprice,
        taxpercentage: item.taxpercentage,
        baseprice: item.baseprice,
        isLock: "SALEPRICE",
        isStock: item.isStock,
        quantity: item.quantity,
        itemNo: item.itemNo || "",
        note: item.note || "",
        imode: item.imode,
        ...(item.unitConfig && {
          unitLocked: true,
          unitConfig: item.unitConfig,
        }),
      };

      if (item.imode === "SERVICE") {
        return {
          serviceId: item._id,
          serviceByName: item.serviceByName || "",
          ...commonFields,
        };
      }

      if (item.imode === "RECHARGE") {
        return {
          walletid: item.walletid || "",
          operator: item.operator || "",
          number: item.number || "",
          ...commonFields,
        };
      }

      // PRODUCT (default)
      return {
        _id: item._id,
        code: item.code,
        ...commonFields,
      };
    });

    var saleData = {
      saleid: saleid,
      customerid: selectedCustomer?._id ?? "",
      // imode: imode,
      saleitems: saleItems,
      ...(projectId && { projectid: projectId }),
      // totalqty: totalQty,
      // totalmrp: totalSoldRes.totalmrp,
      // totalsaleprice: totalSaleRes.totalsaleprice,
      // totalsoldprice: totalSoldRes.totalsaleprice,
      // totalbaseprice: totalSoldRes.totalbaseprice,
      // totaldiscount: totalSoldRes.totaldiscount,
      // totaltaxamount: totalSoldRes.totaltaxamount,
      // grandtotal: totalSoldRes.grandtotal,
      // sgstamount: totalSoldRes.sgstamount,
      // cgstamount: totalSoldRes.cgstamount,
      // igstamount: totalSoldRes.igstamount,
      // amountinwords: totalSoldRes.amountinwords,
      waveoffamount: 0,
      cashamount: CurrencyConverter.toSubunit(cash || 0, "INR"),
      cardamount: CurrencyConverter.toSubunit(card || 0, "INR"),
      upiamount: CurrencyConverter.toSubunit(upi || 0, "INR"),
      // discount: CurrencyConverter.toSubunit(discount || 0, "INR"),
      paylateramount: CurrencyConverter.toSubunit(paylater || 0, "INR"),
      // paidamount: totalPaid,
      cardchange: 0,
      onlinechange: 0,
      onlineamount: CurrencyConverter.toSubunit(online || 0, "INR"),
      changeamount: CurrencyConverter.toSubunit(
        changeData.changeamount || 0,
        "INR",
      ),
      waveoffchange: CurrencyConverter.toSubunit(
        changeData.wavedoffchange || 0,
        "INR",
      ),
      cashchange: CurrencyConverter.toSubunit(
        changeData.cashchange || 0,
        "INR",
      ),
      upichange: CurrencyConverter.toSubunit(changeData.upichange || 0, "INR"),
      paylaterchange: CurrencyConverter.toSubunit(
        changeData.paylaterchange || 0,
        "INR",
      ),
    };
    if (saleDateApi && saleDateApi !== originalSaleDate) {
      saleData.saledate = saleDateApi;
    }
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      var data = saleData;
      var saleResp = await AxiosInstance.patch(`module/sale/`, data);
      showAlert("success", Messages.SUCCESS.SALE_UPDATED);
      handleReset();
      navigate(backTo, {
        state: {
          modalData: { ...saleResp.data.results },
        },
      });
      onDone?.();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleReset = () => {
    handleCancel();
  };

  const salepriceEdit = (cItem, index) => {
    // console.log(cItem);
    setEditSalePriceData({
      ...cItem,
      mrp: cItem.mrp,
      saleprice: cItem.saleprice,
      taxpercentage: cItem.taxpercentage,
      cIndex: index,
      cMode: "OLDEDIT",
    });
    setEditSalePriceModelOpen(true);
  };

  const RechargeEdit = async (cItem, index) => {
    setEditRechargeData({
      ...cItem,
      amount: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
      operator: cItem.operator,
      number: cItem.number,
      wallet: cItem.rechargeInfo.wallet.walletname,
      note: cItem.description,
      walletId: cItem.walletid,
      cIndex: index,
    });
    setEditRechargeModelOpen(true);
  };

  const editItem = async (cItem, index) => {
    setServiceData({
      ...cItem,
      mrp: CurrencyConverter.toCurrency(cItem.mrp, "INR"),
      saleprice: CurrencyConverter.toCurrency(cItem.saleprice, "INR"),
      discount: CurrencyConverter.toCurrency(cItem.discount, "INR"),
      baseprice: CurrencyConverter.toCurrency(cItem.baseprice, "INR"),
      taxamount: CurrencyConverter.toCurrency(cItem.taxamount, "INR"),
      cIndex: index,
    });
    // await handleSuggestEstimate();
    setEditServiceModalOpen(true);
  };

  const handleProductNote = (item) => {
    setCurrentNoteProduct(item);
    setNoteModalOpen(true);
  };

  const handleProductNoteClose = () => {
    setNoteModalOpen(false);
    setCurrentNoteProduct(null);
  };
  const saveProductNote = (note) => {
    if (!currentNoteProduct) return;

    setECart((cart) =>
      cart.map((item) =>
        item._id === currentNoteProduct._id ? { ...item, note } : item,
      ),
    );

    handleProductNoteClose();
  };
  const addProductToCart = (product, qty, cMode) => {
    if (cMode === "EDIT") {
      editSalePriceClose();
    }

    const getUpdatedItem = (product, quantity) => {
      const updatedSoldRes = PriceCalculator.getAllPriceList(
        product.mrp,
        product.soldprice,
        product.baseprice,
        product.taxpercentage,
        quantity,
        "SALEPRICE",
      );

      const updatedSaleRes = PriceCalculator.getAllPriceList(
        product.mrp,
        product.saleprice,
        product.baseprice,
        product.taxpercentage,
        quantity,
        product.isLock,
      );

      return {
        ...product,
        soldprice: product.soldprice,
        baseprice: updatedSoldRes.basePrice,
        discount: updatedSoldRes.discount,
        taxamount: updatedSoldRes.taxAmount,
        quantity: quantity,
        lineGrandTotal: updatedSoldRes.lineGrandTotal,
        lineTotalBasePrice: updatedSoldRes.lineTotalBasePrice,
        lineTotalDiscount: updatedSoldRes.lineTotalDiscount,
        lineTotalMrp: updatedSoldRes.lineTotalMrp,
        lineTotalSalePrice: updatedSaleRes.lineTotalSalePrice,
        lineTotalSoldPrice: updatedSoldRes.lineTotalSalePrice,
        lineTotalTaxAmount: updatedSoldRes.lineTotalTaxAmount,
        note: product.note || "",
      };
    };

    setECart((prevCart) => {
      const updatedQuantity = Math.max(1, parseInt(qty) || 0);

      // === 1. Update using cIndex (EDIT mode from cart index) ===
      if (
        typeof product.cIndex === "number" &&
        prevCart[product.cIndex] &&
        prevCart[product.cIndex]._id === product._id &&
        prevCart[product.cIndex].mrp === product.mrp &&
        prevCart[product.cIndex].saleprice === product.saleprice &&
        prevCart[product.cIndex].taxpercentage === product.taxpercentage
      ) {
        return prevCart.map((item, index) =>
          index === product.cIndex
            ? getUpdatedItem(product, updatedQuantity)
            : item,
        );
      }

      // === 2. Update if product already exists in cart ===
      const existingProductIndex = prevCart.findIndex(
        (item) =>
          item._id === product._id &&
          item.mrp === product.mrp &&
          item.saleprice === product.saleprice &&
          item.taxpercentage === product.taxpercentage,
      );

      if (existingProductIndex !== -1) {
        let newQuantity = updatedQuantity;

        if (product.isStock && product.stockLeft !== undefined) {
          newQuantity = Math.min(newQuantity, product.stockLeft);
        }

        return prevCart.map((item, index) =>
          index === existingProductIndex
            ? getUpdatedItem(product, newQuantity)
            : item,
        );
      }

      // === 3. Add as new product (like service add) ===
      const initialQuantity = updatedQuantity;
      const saleRes = PriceCalculator.getAllPriceList(
        product.mrp,
        product.saleprice,
        product.baseprice,
        product.taxpercentage,
        initialQuantity,
        product.isLock,
      );

      const soldRes = PriceCalculator.getAllPriceList(
        product.mrp,
        product.soldprice,
        product.baseprice,
        product.taxpercentage,
        initialQuantity,
        "SALEPRICE",
      );

      return [
        ...prevCart,
        {
          ...product,
          soldprice: product.soldprice,
          baseprice: soldRes.basePrice,
          discount: soldRes.discount,
          taxamount: soldRes.taxAmount,
          quantity: initialQuantity,
          lineGrandTotal: soldRes.lineGrandTotal,
          lineTotalBasePrice: soldRes.lineTotalBasePrice,
          lineTotalDiscount: soldRes.lineTotalDiscount,
          lineTotalMrp: soldRes.lineTotalMrp,
          lineTotalSalePrice: saleRes.lineTotalSalePrice,
          lineTotalSoldPrice: soldRes.lineTotalSalePrice,
          lineTotalTaxAmount: soldRes.lineTotalTaxAmount,
          note: product.note || "",
        },
      ];
    });
  };

  const handleEditServiceClose = () => {
    setEditServiceModalOpen(false);
  };

  const UpdateServiceToCart = (citem, qty, cMode) => {
    if (cMode === "EDIT") handleEditServiceClose();
    setECart((prevCart) => {
      const updatedCart = prevCart.map((item) => {
        if (item.itemNo === citem.itemNo) {
          const updatedQuantity = parseInt(qty);

          const updatedSaleRes = PriceCalculator.getAllPriceList(
            item.mrp,
            citem.saleprice,
            item.baseprice,
            item.taxpercentage,
            updatedQuantity,
            item.isLock,
          );
          const updatedSoldRes = PriceCalculator.getAllPriceList(
            item.mrp,
            citem.soldprice,
            item.baseprice,
            item.taxpercentage,
            updatedQuantity,
            "SALEPRICE",
          );

          return {
            ...item,
            ...citem,
            quantity: updatedQuantity,
            baseprice: updatedSoldRes.basePrice,
            discount: updatedSoldRes.discount,
            taxamount: updatedSoldRes.taxAmount,
            lineGrandTotal: updatedSoldRes.lineGrandTotal,
            lineTotalBasePrice: updatedSoldRes.lineTotalBasePrice,
            lineTotalDiscount: updatedSoldRes.lineTotalDiscount,
            lineTotalMrp: updatedSoldRes.lineTotalMrp,
            lineTotalSalePrice: updatedSaleRes.lineTotalSalePrice,
            lineTotalSoldPrice: updatedSoldRes.lineTotalSalePrice,
            lineTotalTaxAmount: updatedSoldRes.lineTotalTaxAmount,
          };
        }
        return item;
      });
      return updatedCart;
    });
  };

  const addRechargeToCart = (rechargeData) => {
    const quantity = 1;
    const amount = parseFloat(rechargeData.amount || 0);
    const subunitAmount = CurrencyConverter.toSubunit(amount.toFixed(2), "INR");

    const priceResult = PriceCalculator.getAllPriceList(
      subunitAmount,
      subunitAmount,
      subunitAmount,
      0,
      quantity,
      "SALEPRICE",
    );

    const newRecharge = {
      imode: "RECHARGE",
      isLock: rechargeData.isLock,
      isStock: false,
      walletid: rechargeData.walletId,
      title: `Recharge - ${rechargeData.operator} - ${rechargeData.number}`,
      operator: rechargeData.operator,
      number: rechargeData.number,
      wallet: rechargeData.wallet,
      description: rechargeData.note || "recharge",
      quantity,
      itemNo: rechargeData.itemNo,
      mrp: subunitAmount,
      saleprice: subunitAmount,
      soldprice: subunitAmount,
      baseprice: subunitAmount,
      taxpercentage: 0,
      discount: priceResult.discount,
      taxamount: priceResult.taxAmount,
      rechargeInfo: {
        wallet: {
          walletname: rechargeData.wallet,
        },
      },
      lineGrandTotal: priceResult.lineGrandTotal,
      lineTotalBasePrice: priceResult.lineTotalBasePrice,
      lineTotalDiscount: priceResult.lineTotalDiscount,
      lineTotalMrp: priceResult.lineTotalMrp,
      lineTotalSalePrice: priceResult.lineTotalSalePrice,
      lineTotalSoldPrice: priceResult.lineTotalSalePrice,
      lineTotalTaxAmount: priceResult.lineTotalTaxAmount,
    };

    setECart((prev) => {
      if (
        typeof rechargeData.cIndex === "number" &&
        prev[rechargeData.cIndex]
      ) {
        return prev.map((item, index) =>
          index === rechargeData.cIndex ? newRecharge : item,
        );
      }
      return prev;
    });
  };

  const handleCustomerModalOpen = () => {
    handleResetCustomer();
    setCustomerModalOpen(true);
  };

  const handleCustomerModalClose = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  // const handleCustomerNumbersuggestion = async () => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance("module/customer/suggestion/phone");
  //     const result = response.data.results;
  //     setNumberSuggest(result);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleCustomerAdd = async (newData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        shippingAddress: {
          addressline1: newData.shippingaddressline1,
          addressline2: newData.shippingaddressline2,
          district: newData.shippingdistrict,
          city: newData.shippingcity,
          state: newData.shippingstate,
          statecode: newData.shippingstatecode,
          country: newData.shippingcountry,
          pincode: newData.shippingpincode,
        },

        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      const response = await AxiosInstance.post(`module/customer`, data);
      showAlert("success", Messages.SUCCESS.CUSTOMER_ADDED);
      const result = response.data.results;
      if (result.name !== newData.name) {
        showAlert(
          "warning",
          `The phone number"${result.phone}" already exists .`,
        );
        // handleCloseModal();
        return true;
      }
      handleResetAddCustomer();
      handleSelectCustomer(response.data.results);
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //     fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    } finally {
      setBtnLoading(false);
    }
  };

  const handleResetCustomer = () => {
    setCustomerSuggestions([]);
    setCustomerSearchTerm("");
  };

  const handleResetAddCustomer = () => {
    setCustomerModalOpen(false);
    setCustomerData(null);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && customerSearchTerm.trim()) {
      handleCustomerModalOpen();
    }
  };

  // const handleEnterFocus = (e, nextRef) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     nextRef?.current?.focus();
  //   }
  // };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleUpdate(e);
    }
  };

  const handleCustomerKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, customerSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      const trimmedSearch = customerSearchTerm.trim();

      if (trimmedSearch === "") {
        cashRef.current?.focus();
        return;
      }

      const noSelection = highlightedIndex === -1;
      const hasExactMatch = customerSuggestions.some((customer) => {
        const nameMatch =
          customer.name.toLowerCase() === trimmedSearch.toLowerCase();
        const phoneMatch = customer.phone === trimmedSearch;
        return nameMatch || phoneMatch;
      });

      if (noSelection && !hasExactMatch) {
        handleCustomerModalOpen();
        return;
      }

      if (highlightedIndex >= 0) {
        const selected = customerSuggestions[highlightedIndex];
        handleSelectCustomer(selected);
        setShowCustomerDropdown(false);
        setCustomerSearchTerm("");
        setHighlightedIndex(-1);
      }
    }
  };

  const addNewServiceName = (name) => {
    if (
      !serviceNameSuggest.some(
        (s) => s.serviceByName?.toLowerCase() === name?.toLowerCase(),
      )
    ) {
      setServiceNameSuggest((prev) => [
        { _id: Date.now(), serviceByName: name },
        ...prev,
      ]);
    }
  };

  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };

  const handleNewGroupOpen = () => {
    setNewGroupOpen(true);
  };

  const handleCustomerGroupAdd = async (groupName, method) => {
    setAddGroupLoad(true);
    try {
      const data = {
        name: groupName,
      };
      const response = await AxiosInstance.post("module/customer/group", data);
      const results = response.data.results;
      //  setGroupName(results);
      setGroupName((prev) => [
        { ...results },
        ...(Array.isArray(prev) ? prev : []),
      ]);
      showAlert("success", "Customer Group Added Successfull");
      setAddGroupLoad(false);
      handleNewGroupClose();
      setNewGroupName(results);
      if (method === "ADD") {
        handleCustomerModalOpen();
      } else {
        openEditModal(isEditData);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setAddGroupLoad(false);
    }
  };

  useEffect(() => {
    const handleArrowAndEnter = (e) => {
      // Only handle when search term is empty or suggestions list is empty
      if (!(customerSearchTerm?.trim() === "")) return;
      if (!(customerSuggestions?.length === 0)) return;

      if (
        noteModalOpen ||
        isEditSalePriceModelOpen ||
        isEditRechargeModelOpen ||
        isEditServiceModalOpen ||
        isEditModalOpen ||
        isCustomerModalOpen ||
        isChangeModalOpen ||
        isSaleModalOpen ||
        isQuantityModalOpen ||
        globelPopupOpen
      )
        return;

      if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

      e.preventDefault();

      const tableRows = Array.from(document.querySelectorAll("table tbody tr"));
      if (!tableRows.length) return;

      const currentRow = document.activeElement.closest("tr");
      let currentIndex = tableRows.indexOf(currentRow);

      // Handle Enter key
      if (e.key === "Enter") {
        if (currentIndex >= 0) {
          const item = tableRows[currentIndex].dataset.item
            ? JSON.parse(tableRows[currentIndex].dataset.item)
            : null;

          if (item) {
            if (item.imode === "SERVICE") {
              editItem(item, currentIndex);
            } else if (item.imode === "RECHARGE") {
              RechargeEdit(item, currentIndex);
            } else if (item.imode === "PRODUCT") {
              salepriceEdit(item, currentIndex);
            }
          }
        }
        return;
      }

      // Virtual -1: no row focused yet
      if (currentIndex === -1) {
        if (e.key === "ArrowDown") {
          tableRows[0].tabIndex = 0;
          tableRows[0].focus();
        } else if (e.key === "ArrowUp") {
          tableRows[tableRows.length - 1].tabIndex = 0;
          tableRows[tableRows.length - 1].focus();
        }
        return;
      }

      // Remove tabIndex from current row
      currentRow.tabIndex = -1;

      // Calculate next/previous index
      let nextIndex =
        e.key === "ArrowDown"
          ? (currentIndex + 1) % tableRows.length
          : (currentIndex - 1 + tableRows.length) % tableRows.length;

      const nextRow = tableRows[nextIndex];
      nextRow.tabIndex = 0;
      nextRow.focus();
    };

    window.addEventListener("keydown", handleArrowAndEnter);
    return () => window.removeEventListener("keydown", handleArrowAndEnter);
  }, [
    noteModalOpen,
    isEditSalePriceModelOpen,
    isEditRechargeModelOpen,
    isEditServiceModalOpen,
    isEditModalOpen,
    isCustomerModalOpen,
    isChangeModalOpen,
    isSaleModalOpen,
    isQuantityModalOpen,
    customerSuggestions,
    customerSearchTerm,
    globelPopupOpen,
  ]);

  useEffect(() => {
    if (highlightedIndex >= 0 && suggestionRefs.current[highlightedIndex]) {
      suggestionRefs.current[highlightedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    // handleSuggestEstimate();
    // handleCustomerNumbersuggestion()
    if (hasModulePermission("SERVICE") || permission === undefined) {
      handleSuggestService();
    }
  }, []);

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row py-0">
              <div className="col-lg-9">
                <div className="card">
                  <div className="card-header bg-header px-3 py-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <h6 className="mb-0 bg-text">
                      Edit Sale -{" "}
                      <span className="badge rounded-pill bg-label-star">
                        {saleNo}
                      </span>
                    </h6>
                    <div className="mb-0">
                      <div className="input-group w-200">
                        <button className="input-group-text">
                          <CalendarIcon/>
                        </button>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            open={openDatePicker}
                            onOpen={() => setOpenDatePicker(true)}
                            onClose={() => setOpenDatePicker(false)}
                            disableOpenPicker
                            value={saleDate}
                            onChange={handleSaleDate}
                            format="DD MMM YYYY"
                            minDate={minDate} // last 5 months only
                            maxDate={maxDate} // no future dates
                            slotProps={{
                              textField: {
                                size: "small",
                                className: "form-control cursor-pointer",
                                onClick: () => setOpenDatePicker(true),
                                inputProps: { readOnly: true },
                                onKeyDown: (e) => e.preventDefault(),
                                sx: {
                                  "& .MuiInputBase-input": {
                                    cursor: "pointer",
                                  },
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div>

                  <div className="card-body px-0">
                    <div className="table-responsive mt-0">
                      <table className="table table-bordered align-middle mb-0">
                        <thead className="table-light">
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="w-30">Description</th>
                            <th className="text-center">MRP</th>
                            <th className="text-center">Discount</th>
                            <th className="text-center">Sale Price</th>
                            <th className="text-center w-15">Qty</th>
                            <th className="text-center">Total</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ecart.map((item, index) => (
                            <tr
                              key={item.imode + index}
                              className="position-relative  cursor-poInter hover-row"
                              onClick={() => {
                                if (item.imode === "SERVICE") {
                                  editItem(item, index);
                                } else if (item.imode === "RECHARGE") {
                                  RechargeEdit(item, index);
                                } else if (item.imode === "PRODUCT") {
                                  salepriceEdit(item, index);
                                }
                              }}
                              data-item={JSON.stringify(item)}
                            >
                              <td className="text-center">
                                {index + 1}
                                {item.imode === "SERVICE" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-yellow"}/>
                                  </span>
                                )}
                                {item.imode === "RECHARGE" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-yellow"}/>
                                  </span>
                                )}
                                {item.imode === "PRODUCT" && (
                                  <span className="rounded fsz-10 ms-1">
                                    <CircleIcon iClass={"text-yellow"}/>
                                  </span>
                                )}
                              </td>
                              <td className="text-wrap" width="280">
                                {item.title} - &nbsp;
                                <small className="badge rounded-pill bg-label-peace">
                                  {" "}
                                  {item.taxpercentage}%
                                </small>
                                {item.imode === "SERVICE" && (
                                  <div className="ms-0 fs-12">
                                    {item.description}
                                  </div>
                                )}
                                {item.imode === "PRODUCT" && (
                                  <div className="ms-0 fs-12 text-truncate-description text-muted d-flex align-items-start">
                                    <button
                                      type="button"
                                      className="me-2 rounded btn-label-primary shadow-none border-0"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleProductNote(item);
                                      }}
                                    >
                                      <NotepadIcon/>
                                    </button>
                                    {item.note && <span>{item.note}</span>}
                                  </div>
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.mrp || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.discount || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.soldprice || 0,
                                  "INR",
                                )}
                              </td>
                              <td width={120}>
                                {item.imode === "SERVICE" ||
                                item.imode === "RECHARGE" ? (
                                  <span className="text-center d-block">
                                    {item.quantity} {item?.unit}
                                  </span>
                                ) : (
                                  <div className="text-center">
                                    {item.quantity} {item?.unit}
                                  </div>
                                )}
                              </td>
                              <td className="text-center">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  item.lineGrandTotal || 0,
                                  "INR",
                                )}
                              </td>
                              <td className="text-center">
                                <div className="order-actions opacity-0 opacity-md-100">
                                  {item.imode === "SERVICE" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          editItem(item, index);
                                        }}
                                      >
                                        <EditIcon/>
                                      </button>
                                    </>
                                  )}
                                  {item.imode === "RECHARGE" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          RechargeEdit(item, index);
                                        }}
                                      >
                                        <EditIcon/>
                                      </button>
                                    </>
                                  )}
                                  {item.imode === "PRODUCT" && (
                                    <>
                                      <button
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          salepriceEdit(item, index);
                                        }}
                                      >
                                        <EditIcon/>
                                      </button>
                                    </>
                                  )}
                                  <button
                                    className="btn-label-danger shadow-none me-2"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeEItem(index);
                                    }}
                                  >
                                    <DeleteIcon/>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="row bg-light border-0 mt-2 text-center align-items-center m-0">
                      <div className="col p-2">
                        <p className="mb-0">Total MRP</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalmrp || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <MinusIcon iClass={"text-muted"}/>
                      </div>
                      <div className="col p-2">
                        <p className="mb-0">Total Discount</p>
                        <h6 className="mb-0 fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totaldiscount || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                        <LineDoubleIcon iClass={"text-muted"}/>
                      </div>
                      <div className="col bg-dark-purple p-2">
                        <p className="mb-0 bg-dark-purple">Total Amount</p>
                        <h6 className="mb-0 bg-dark-purple fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.totalsaleprice || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                      <div className="col p-2 fs-20">
                      <LineDoubleIcon iClass={"text-muted"}/>
                      <ChevronRightIcon iClass={"text-muted"}/>
                      </div>
                      <div className="col bg-dark-blue p-2">
                        <p className="mb-0 bg-dark-text">
                          Grand Total <small className="fs-14">(Rounded)</small>
                        </p>
                        <h6 className="mb-0 bg-dark-text fs-20">
                          {CurrencyConverter.toCurrency(
                            totalSoldRes.grandtotal || 0,
                            "INR",
                          )}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3">
                <div className="card">
                  <div className="card-body">
                    {!selectedCustomer && (
                      <div className="ms-auto position-relative">
                        <SearchInput
                          searchRef={customerSuggestionsRef}
                          value={customerSearchTerm}
                          onChange={(e) => {
                            handleCustomerSearch(e.target.value);
                            setShowCustomerDropdown(true);
                            setHighlightedIndex(-1);
                          }}
                          onFocus={() => {
                            if (customerSuggestions.length > 0) {
                              setShowCustomerDropdown(true);
                            }
                          }}
                          onSearch={
                            customerSearchTerm.trim()
                              ? () =>
                                  handleCustomerModalOpen(
                                    customerSearchTerm.trim(),
                                  )
                              : null
                          }
                          onKeyPress={handleKeyPress}
                          placeholder="Search customer by name, phone, email, referenceID..."
                          onKeyDown={handleCustomerKeyDown}
                        />
                        {customerSearchTerm &&
                          customerSuggestions.length === 0 && (
                            <ul className="suggestions-list">
                              <li className="suggestion-item text-muted">
                                No customers data was found
                              </li>
                            </ul>
                          )}
                        {showCustomerDropdown &&
                          customerSuggestions.length > 0 && (
                            <ProductSearchList
                              suggest={customerSuggestions}
                              suggestionRefs={suggestionRefs}
                              handleSelect={handleSelectCustomer}
                              activeIndex={highlightedIndex}
                              type="customer"
                            />
                          )}
                      </div>
                    )}
                    <div className="col-lg-12 mt-1">
                      <div className="card shadow-none border-blue mb-0">
                        <div className="card-header bg-label-infoss p-2 d-flex justify-content-between align-items-center">
                          <div className="mb-0">Customer Info</div>
                          {selectedCustomer && (
                            <div>
                              <button
                                type="button"
                                className="btn-label-primary rounded shadow-none border-0"
                                onClick={() => openEditModal(selectedCustomer)}
                              >
                                <EditIcon/>
                              </button>
                              <button
                                type="button"
                                className="btn-label-danger rounded shadow-none border-0 cursor-pointer"
                                onClick={handleRemoveCustomer}
                              >
                                <RemoveIcon/>
                              </button>
                            </div>
                          )}
                        </div>
                        <div className="card-body px-2 py-0">
                          {selectedCustomer ? (
                            <>
                              <p className="my-1 fs-13">
                                Name :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer.name}
                                </span>
                              </p>
                              <p className="my-1 fs-13">
                                Phone :{" "}
                                <span className="fw-600 fs-14">
                                  {selectedCustomer.phone}{" "}
                                </span>
                              </p>
                              {selectedCustomer?.gstnumber && (
                                <p className="my-1 fs-13">
                                  GST :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.gstnumber}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.customerData?.addressline1 && (
                                <p className="my-1 fs-13">
                                  Address :{" "}
                                  <span className="fw-600 fs-14">
                                    {
                                      selectedCustomer?.customerData
                                        ?.addressline1
                                    }
                                  </span>
                                </p>
                              )}
                              {selectedCustomer?.state && (
                                <p className="my-1 fs-13">
                                  State:{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer?.state}
                                  </span>
                                </p>
                              )}
                              {selectedCustomer.referenceid && (
                                <p className="my-1 fs-13">
                                  Reference ID :{" "}
                                  <span className="fw-600 fs-14">
                                    {selectedCustomer.referenceid}
                                  </span>
                                </p>
                              )}
                            </>
                          ) : (
                            <p className="my-2 text-muted">
                              No customers has been selected
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <ProjectSale
                    isActive={isActive}
                    onSelectProject={setProjectId}
                    resetProject={resetProject}
                    selectedProjectId={projectId}
                  />
                </div>

                <div className="card">
                  <div className="card-body">
                    <div className="rounded mb-3">
                      <div className="bg-light  rounded p-2 text-center mb-3">
                        <h6 className="mb-0 fs-18 text-dark">
                          Total Payable :{" "}
                          <span>
                            {" "}
                            {CurrencyConverter.toCurrency(
                              totalSoldRes.grandtotal || 0,
                              "INR",
                            )}{" "}
                          </span>
                        </h6>
                      </div>
                      <div className="flex-grow-1 row justify-content-between align-items-center g-2">
                        <div className="col-6">
                          <h6 className="mb-0">Cash</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            ref={cashRef}
                            type="text"
                            className="form-control"
                            min="0"
                            value={cash}
                            onClick={() => handleFocusFill("cash")}
                            onKeyDown={(e) =>
                              handleEnterFocus(
                                e,
                                cardRef,
                                "cash",
                                cash,
                                "card",
                                card,
                              )
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setCash)}
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0"> Card </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            ref={cardRef}
                            type="text"
                            className="form-control"
                            min="0"
                            value={card}
                            onClick={() => handleFocusFill("card")}
                            onKeyDown={(e) =>
                              handleEnterFocus(
                                e,
                                onlineRef,
                                "card",
                                card,
                                "online",
                                online,
                              )
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setCard)}
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0">Online Pay </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            ref={onlineRef}
                            type="text"
                            className="form-control"
                            min="0"
                            value={online}
                            onClick={() => handleFocusFill("online")}
                            onKeyDown={(e) =>
                              handleEnterFocus(
                                e,
                                upiRef,
                                "online",
                                online,
                                "upi",
                                upi,
                              )
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setOnline)}
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0">UPI </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            ref={upiRef}
                            type="text"
                            className="form-control"
                            min="0"
                            value={upi}
                            onClick={() => handleFocusFill("upi")}
                            onKeyDown={(e) =>
                              handleEnterFocus(
                                e,
                                paylaterRef,
                                "upi",
                                upi,
                                "paylater",
                                paylater,
                              )
                            }
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setUpi)}
                          />
                        </div>

                        {/* <div className="col-6">
                                                    <h6 className="mb-0">Discount</h6>
                                                </div>
                                                <div className="col-6 text-end">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        min="0"
                                                        value={discount}
                                                        onFocus={(e) => e.target.select()}
                                                        onChange={handleInputChange(setDiscount)}
                                                    />
                                                </div> */}

                        <div className="col-6">
                          <h6
                            className={`mb-0 
                                                ${
                                                  balance === 0
                                                    ? "text-grey"
                                                    : balance > 0
                                                      ? "text-danger"
                                                      : "text-success"
                                                }`}
                          >
                            {balance === 0
                              ? "Balance"
                              : balance > 0
                                ? "Balance"
                                : "Change"}
                          </h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className={`form-control ${
                              balance === 0
                                ? "bg-box-grey"
                                : balance > 0
                                  ? "bg-box-danger"
                                  : "bg-box-success"
                            }`}
                            value={CurrencyConverter.toCurrency(
                              balance || 0,
                              "INR",
                            )}
                            disabled
                          />
                        </div>

                        <div className="col-6">
                          <h6 className="mb-0 text-dark fw-500">Total Paid</h6>
                        </div>
                        <div className="col-6 text-end">
                          <input
                            type="text"
                            className="form-control text-dark"
                            value={CurrencyConverter.toCurrency(
                              totalPaid || 0,
                              "INR",
                            )}
                            disabled
                          />
                        </div>
                        <div className="col-6">
                          <h6 className="mb-0 text-brown">Paylater</h6>
                          {oldPaylater !== null && oldPaylater > 0 && (
                            <div className="d-flex align-items-center">
                              <div className="parent-icon">
                                <TimerIcon iClass={"me-1 fs-5"}/>{" "}
                              </div>
                              <span>₹{oldPaylater}</span>
                            </div>
                          )}
                        </div>
                        <div className="col-6 text-end">
                          <input
                            ref={paylaterRef}
                            type="text"
                            className="form-control"
                            min="0"
                            value={paylater}
                            onClick={() => handleFocusFill("paylater")}
                            onKeyDown={(e) => handlePaymodeKeyDown(e)}
                            onFocus={(e) => e.target.select()}
                            onChange={handleInputChange(setPaylater)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="d-block">
                      <button
                        type="button"
                        className="btn shadow-none btn-outline-secondary text-left"
                        onClick={handleCancel}
                      >
                        <XIcon/> Cancel
                      </button>
                      {isBtnLoading ? (
                        <button
                          className="btn btn-primary pb-0 text-right"
                          disabled
                        >
                          <CircularProgress size={22} className="text-white" />
                        </button>
                      ) : (
                        <button
                          ref={buttonRef}
                          type="button"
                          className="btn btn-primary text-right w-48"
                          onClick={handleUpdate}
                        >
                          <CheckIcon/> Save
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isQuantityModalOpen && (
            <EditUpdateQty
              data={isQuantityData}
              updateIndex={isEditCartIndex}
              updateQuantity={handleQuantityUpdate}
              onClose={handleQuantityClose}
            />
          )}

          {isAlertModalOpen && <EditAlert onClose={handleAlertClose} />}

          {isChangeModalOpen && (
            <ChangeModal
              changeAmount={balance}
              onClose={handleChangeModalClose}
              onConfirm={handleChangeConfirm}
            />
          )}

          {isEditServiceModalOpen && (
            <EditService
              onClose={handleEditServiceClose}
              onUpdate={UpdateServiceToCart}
              editData={isServiceData}
              isBtnLoading={isBtnLoading}
              estimateSuggest={estimateSuggest}
              // serviceNameSuggests={serviceNameSuggest}
              addNewServiceName={addNewServiceName}
              isServiceName={true}
              showQuanity={false}
            />
          )}

          {isEditRechargeModelOpen && (
            <EditRecharge
              editData={isEditRechargeData}
              onClose={handleEditRechargeClose}
              onAdd={addRechargeToCart}
              isBtnLoading={isBtnLoading}
            />
          )}

          {/* {isCustomerModalOpen && (
        <CustomerModal
          onClose={handleCustomerModalClose}
          onConfirm={handleCustomerAdd}
          onData={isCustomerData}
          isBtnLoading={isBtnLoading}
          groupName={groupName}
          onNewGroupsIn={handleCustomerGroupAdd}
          newGroup={newGroupName}
        />
      )} */}

          {isEditSalePriceModelOpen && (
            <UpdatePrice
              data={isEditSalePriceData}
              addToCart={addProductToCart}
              onClose={editSalePriceClose}
            />
          )}

          {isDeleteModalOpen && (
            <DeleteModal
              onClose={() => setDeleteModalOpen(false)}
              onConfirm={() => handleDelete()}
              isLable={" Sale " + isDeleteData?.saleno}
              isBtnLoading={isBtnLoading}
            />
          )}

          <AddCustomer
            isOpen={isCustomerModalOpen}
            onClose={handleCustomerModalClose}
            onData={isCustomerData}
            onAdd={handleCustomerAdd}
            isBtnLoading={isBtnLoading}
            groupName={groupName}
            onNewGroupsIn={handleCustomerGroupAdd}
            newGroup={newGroupName}
            resetAll={true}
            error={error}
            setErrors={setErrors}
            numberSuggest={numberSuggest}
            addNewCustomNumber={addNewCustomNumber}
          />

          {isEditModalOpen && (
            <EditCutomer
              editData={isEditData}
              onClose={closeEditModal}
              onEdit={handleUpdte}
              isBtnLoading={isBtnLoading}
              groupName={groupName}
              groupId={selectedCustomer?.groupid}
              onNewGroupsIn={handleCustomerGroupAdd}
              resetAll={true}
              newGroup={newGroupName}
              error={error}
              setErrors={setErrors}
            />
          )}

          {noteModalOpen && (
            <ProductNoteModal
              onClose={handleProductNoteClose}
              onSave={saveProductNote}
              initialNote={currentNoteProduct?.note || ""}
            />
          )}
        </div>
      </div>
    </>
  );
};
export default OldEditSale;
